import { WorkspaceChannelPlatform } from "@/api/__generated__/models";
import { getAssetsUrl } from "@/constants/url";

export const DEBUT_BOONE_CAMPAIGN_ID = "5d168365-e337-45cb-afce-fcb1fc52c84b";

export const HANZ_FALLING_CAMPAIGN_ID = "7f854fc0-a36d-49b3-ad7a-046a06f82f66";
export const BENSON_BOONE_CAMPAIGN_ID = "3ae9c7ca-2121-4ea4-af1a-47a5fda4a61b";
export const MIO_TIMEOUT_CAMPAIGN_ID = "0f52a9ea-0a4d-424f-a89a-c691899286b0";
export const HANZ_BEST_FRIEND_CAMPAIGN_ID = "d4cb0a42-80bb-4600-b1d8-b1a0044c1cc8";

export type CampaignIdType =
  | typeof HANZ_FALLING_CAMPAIGN_ID
  | typeof BENSON_BOONE_CAMPAIGN_ID
  | typeof MIO_TIMEOUT_CAMPAIGN_ID
  | typeof HANZ_BEST_FRIEND_CAMPAIGN_ID;

const HANZ_BEST_FRIEND_CAMPAIGN_INFO = {
  id: HANZ_BEST_FRIEND_CAMPAIGN_ID,
  title: "Hanz - Best Friend",
  about: `🪄 Share the Highlight Moment with Your Besties.

📢 Preview Access Before the full track officially releases on May 25th, we’re giving you early access to the highlight part of the song. Choose a moment that matches this emotional sound!`,
  platform: WorkspaceChannelPlatform.TIKTOK,
  target_country: "US",
  uploadDate: "2025-05-27",
  guideLine: `• "He's older now… / but still my best friend."
• "What I found in Thailand…. / my best friend. "
• "What I found in high school…..  / my bestie who stayed for life."
• "We’re busy now… / but still the one I call first."
`,
  campaignUploadStartDate: "2025-05-27",
  campaignUploadEndDate: "2025-06-02",
  musicReleaseDateTime: "2025-05-25 20:00",
  musicVideoUrl: null,
  sampleVideos: [
    {
      title: `🎬 Version 1: "What I Found"`,
      url: getAssetsUrl("campaign/hanz-best_friend/best_friend_sample_1.mp4"),
    },
    {
      title: `🕰️ Version 2: "Then & Now"`,
      url: getAssetsUrl("campaign/hanz-best_friend/best_friend_sample_2.mp4"),
    },
  ],
  styles: {
    text: "",
    heroText: "",
    hero: "",
    cta: "",
    border: "",
    bgLight: "",
  },
  material: {
    title: "",
    short_title: "",
    isrc: "",
    shortsUrl: "",
    cover: `${getAssetsUrl("campaign/hanz-best_friend/cover.webp")}`,
    hero: "",
    bannerMobile: "",
    bannerDesktop: "",
    music: "",
  },
};

const BENSON_BOONE_CAMPAIGN_INFO = {
  id: "3ae9c7ca-2121-4ea4-af1a-47a5fda4a61b",
  title: "Make It Magical: A Creator Campaign for Benson Boone's New Track",
  about: `🌙🍦🪄 We look forward to seeing your magical creations!
Benson Boone’s “Mystical Magical,” released April 24, 2025, is a vibrant pop-rock track capturing the whimsical essence of love. To celebrate, we’re launching a TikTok creator campaign inviting high-quality, original short-form videos that are emotionally resonant, easy to replicate, and spark sound reuse.`,
  guideLine: `Your video can be in any style. Just include one key transition point:

🎵 
Moonbeam ice cream, taking off your blue jeans
Dancing at the movies 
'Cause it feels so...
(Insert your video transition here!)
Mystical, magical...

This is where the song shifts from calm to energetic — we want that moment to pop. Aside from that, it’s all yours. Be creative. Make it yours. Make it fun!`,
  trackName: "Mystical Magical",
  artistName: "Benson Boone",
  campaignUploadStartDate: "2025-05-05",
  campaignUploadEndDate: "2025-05-10",
  musicReleaseDateTime: "2025-04-24",
  estimatedEarnings: "",
  applyDates: "10 days to apply",
  platform: WorkspaceChannelPlatform.TIKTOK,
  target_country: "",
  uploadDate: "2025-04-30",
  musicVideoUrl: "",
  sampleVideos: null,
  styles: {
    text: "",
    heroText: "",
    hero: "",
    cta: "",
    border: "",
    bgLight: "",
  },
  material: {
    title: "Benson Boone - Mystical Magical",
    short_title: "Mystical Magical",
    isrc: "",
    shortsUrl: "",
    cover: `${getAssetsUrl("campaign/benson-boone/cover.webp")}`,
    hero: "",
    bannerMobile: "",
    bannerDesktop: "",
    music: "",
  },
};

const MIO_TIMEOUT_CAMPAIGN_INFO = {
  id: "0f52a9ea-0a4d-424f-a89a-c691899286b0",
  title: "Mio - Timeout",
  about: "",
  platform: WorkspaceChannelPlatform.TIKTOK,
  uploadDate: "2025-05-27",
  steps: [
    {
      title: "Step 1",
      description: "Upload a video to TikTok",
    },
  ],
  guideLine: "",
  campaignUploadStartDate: "2025-05-05",
  campaignUploadEndDate: "2025-05-10",
  musicReleaseDateTime: "2025-04-24",
  musicVideoUrl: "",
  sampleVideos: null,
  styles: {
    text: "",
    heroText: "",
    hero: "",
    cta: "",
    border: "",
    bgLight: "",
  },
  material: {
    title: "Mio - Timeout",
    short_title: "Timeout",
    isrc: "",
    shortsUrl: "",
    cover: `${getAssetsUrl("campaign/mioo-time_out/cover.webp")}`,
    hero: "",
    bannerMobile: "",
    bannerDesktop: "",
    music: "",
  },
  target_country: "",
};

const HANZ_FALLING_CAMPAIGN_INFO = {
  title: "[Create & Earn] Hanz - Falling",
  about: "",
  platform: WorkspaceChannelPlatform.YOUTUBE_SHORTS,
  uploadDate: "",
  guideLine: "",
  campaignUploadStartDate: "2025-05-05",
  campaignUploadEndDate: "2025-05-10",
  musicReleaseDateTime: "2025-04-24",
  musicVideoUrl: "",
  sampleVideos: null,
  styles: {
    text: "text-[#d4b5f3]",
    heroText: "text-[#d4b5f3] !text-[56px]",
    hero: "",
    cta: "bg-[#d4b5f3] hover:bg-[#c9a0ef] text-black",
    border: "border-[#d4b5f3]",
    bgLight: "bg-[#4c5060]",
  },
  material: {
    title: "Hanz - Falling",
    short_title: "Falling",
    isrc: "KRA532402182",
    shortsUrl: "https://youtube.com/source/T9MUAafO_x0/shorts?si=ucuP-8b2uUFIP68j",
    cover: `${getAssetsUrl("campaign/hanz-falling-cover.avif")}`,
    hero: `${getAssetsUrl("campaign/hanz-falling-detail.webp")}`,
    bannerMobile: `${getAssetsUrl("campaign/hanz-falling-banner-mobile.png")}`,
    bannerDesktop: `${getAssetsUrl("campaign/hanz-falling-banner-desktop.png")}`,
    music: `${getAssetsUrl("campaign/hanz-falling.mp3")}`,
  },
  target_country: "United states",
} as const;

export const CAMPAIGN_INFO: Record<
  string,
  | typeof HANZ_FALLING_CAMPAIGN_INFO
  | typeof BENSON_BOONE_CAMPAIGN_INFO
  | typeof MIO_TIMEOUT_CAMPAIGN_INFO
  | typeof HANZ_BEST_FRIEND_CAMPAIGN_INFO
> = {
  [HANZ_FALLING_CAMPAIGN_ID]: HANZ_FALLING_CAMPAIGN_INFO,
  [BENSON_BOONE_CAMPAIGN_ID]: BENSON_BOONE_CAMPAIGN_INFO,
  [MIO_TIMEOUT_CAMPAIGN_ID]: MIO_TIMEOUT_CAMPAIGN_INFO,
  [HANZ_BEST_FRIEND_CAMPAIGN_ID]: HANZ_BEST_FRIEND_CAMPAIGN_INFO,
};

export const CAMPAIGN_NOTICES = [
  {
    title: "Participation Criteria",
    content: [
      "Only BackPac users who have successfully registered for the campaign may participate.",
      "Only one video per user can participate in this campaign.",
      "When uploading your video, please ensure you mark it as [Paid Promotion].",
    ],
  },
  {
    title: "Period and View Eligibility",
    content: [
      "The campaign will automatically end once the campaign period finishes or when the total target of 3 million views is reached, whichever comes first.",
      "Views generated after the campaign ends are not eligible for rewards.",
      "Eligible views for campaign participation are calculated based on YouTube Analytics reports accessed directly from each authorized channel.",
      "Internal view counts may differ from the real-time view counts shown in YouTube Studio.",
    ],
  },
  {
    title: "Reward",
    content: [
      "Rewards will be finalized between March 24 and April 6.",
      "Videos deleted before this period will not be eligible for rewards.",
      "Videos uploaded on a different date than the one selected during registration will not receive rewards.",
      "Videos that do not follow the provided production guidelines will not be eligible for rewards.",
      "Videos must use only the designated track listed on the campaign page to qualify for rewards.",
      "Videos containing additional audio tracks or overlapping music will not be rewarded.",
    ],
  },
  {
    title: "AdSense and Video Impact",
    content: ["Using the designated track will not impact AdSense earnings generated by your Shorts videos."],
  },
];
